import React from 'react';
import { formatNumber } from '../../../lib/utils';

export default class RecipientAccountNavigationHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentIndex: this.getCurrentNavIndex()
        };
    }

    componentDidMount() {
        window.onbeforeunload = () => {
            if (this.props.prevPage && this.props.prevPage.indexOf("Applications") > 0 &&
                this.props.prevPage.indexOf("Campaign List") < 0) {
                //because redux store with application table configuration will be cleared out, reset prevPage to Applications so navigation component is hidden
                this.props.history.replace({ state: { ...this.props.history.location.state, prevPage: "Applications" } });
            }
        }
    }

    componentWillMount() {
        if (this.props.prevPage &&
            (
                this.props.prevPage.indexOf("Applications") >= 0
                || this.props.prevPage.indexOf("Campaign") >= 0
                || this.props.prevPage.indexOf("Campaign List") >= 0
                )) 
        {
            this.getApplicationsNavigationMapping();
        }
    }

    getCurrentNavIndex = () => {
        let currentApplicationId = this.props.applicationId;
        
        if (!currentApplicationId) {
            return this.props.applicationsToRecipientIdsMapping.data.orderedApplications.indexOf(parseInt(this.props.recipientId));
        }
        return this.props.applicationsToRecipientIdsMapping.data.orderedApplications.indexOf(currentApplicationId);
    }

    async getApplicationsNavigationMapping() {
        await this.props.getApplicationsToRecipientIdsMapping(this.props.campaignId, this.props.campaignListId);
        if (this.props.applicationsToRecipientIdsMapping.success) {
            this.setState({
                currentIndex: this.getCurrentNavIndex()
            });
        }
    }

    navigate(next) {
        const newIndex = next ? this.state.currentIndex + 1 : this.state.currentIndex - 1;
        
        if (this.props.prevPage.indexOf("Campaign List") >= 0 && this.props.prevPage.indexOf("Applications") < 0) {
            const recipientId = this.props.applicationsToRecipientIdsMapping.data.orderedApplications[newIndex];
            
            if (recipientId) {
                this.props.getAccountDetails(recipientId);
                this.setState({ currentIndex: newIndex });
            }
        }
        else {
            const applicationId = this.props.applicationsToRecipientIdsMapping.data.orderedApplications[newIndex];
            const recipientId = this.props.applicationsToRecipientIdsMapping.data.mapping[applicationId];
            
            if (recipientId) {
                this.props.getAccountDetails(recipientId, applicationId);
                this.setState({ currentIndex: newIndex });
            }
        }
    }

    render() {
        const totalApplications = this.props.applicationsToRecipientIdsMapping.data.orderedApplications.length;
        const currentIndex = this.state.currentIndex;

        return (
            <div className="subheader application-details-subheader">
                {this.props.prevPage && !this.props.applicationsToRecipientIdsMapping.loading && this.props.applicationsToRecipientIdsMapping.success
                    && <div className="container flex-justify">
                        <div >
                            {(totalApplications > 0 && currentIndex >= 0 &&
                                (this.props.prevPage.indexOf("Applications") >= 0
                                    || this.props.prevPage.indexOf("Campaign") >= 0
                                    || this.props.prevPage.indexOf("Campaign List") >= 0))
                                && <div className="flex-center previous-next-arrows">
                                    <p className="previous" onClick={this.navigate.bind(this, false)}>
                                        <i className={`icon ion-ios-arrow-back accent-text2 ${currentIndex <= 0 ? 'disabled' : ''}`}></i>
                                        <span className={`link-text ${currentIndex === 0 ? 'disabled' : ''}`}>Previous</span>
                                    </p>
                                    <p className="accent-text medium-text">
                                        {formatNumber(currentIndex + 1)} of {formatNumber(totalApplications)} {this.props.prevPage}{
                                            this.props.prevPage.indexOf("Applications") >= 0 ? ""
                                            : this.props.prevPage.indexOf("Campaign List") >= 0 ? " Participants" : " Individual Recipients"
                                        }
                                    </p>
                                    <p className="next" onClick={this.navigate.bind(this, true)}>
                                        <span className={`link-text ${currentIndex === (totalApplications - 1) ? 'disabled' : ''}`}>Next</span>
                                        <i className={`icon ion-ios-arrow-forward accent-text2 ${(currentIndex < 0 || currentIndex === totalApplications - 1) ? 'disabled' : ''}`}></i>
                                    </p>
                                </div>}
                        </div>
                        <div className="back-link">
                            <i className="icon ion-android-arrow-back middle medium-text"></i>
                            <span onClick={() => this.props.history.goBack()} className="link-text small-text">Back to {this.props.prevPage}</span>
                        </div>
                    </div>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/RecipientAccountNavigationHeader.jsx